<template>
  <div class="min-h-screen bg-gray-100 lg:flex">
    <!-- Sidebar -->
    <AdminSidebar :open="sidebarOpen" @close="sidebarOpen = false" />

    <div class="flex min-w-0 flex-1 flex-col">
      <!-- Top bar -->
      <header class="sticky top-0 z-30 flex items-center justify-between gap-4 border-b border-gray-200 bg-white/90 px-4 py-3 backdrop-blur sm:px-6">
        <div class="flex min-w-0 items-center gap-3">
          <button
            class="rounded-md p-2 text-gray-600 hover:bg-gray-100 lg:hidden"
            aria-label="Open menu"
            @click="sidebarOpen = true"
          >
            <i class="fa-solid fa-bars"></i>
          </button>
          <h1 class="truncate font-serif text-xl font-bold text-gray-900">{{ pageTitle }}</h1>
        </div>

        <div class="flex items-center gap-2 sm:gap-3">
          <router-link to="/" class="btn-ghost btn-sm" title="View website">
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
            <span class="hidden sm:inline">View site</span>
          </router-link>
          <div class="hidden items-center gap-2 rounded-md border border-gray-200 bg-white py-1 pl-1 pr-3 md:flex">
            <span class="flex h-7 w-7 items-center justify-center rounded bg-brand-red text-xs font-bold text-white">{{ initial }}</span>
            <span class="max-w-[140px] truncate text-sm font-medium text-gray-700">{{ userName }}</span>
          </div>
          <button class="btn-primary btn-sm" @click="logout">
            <i class="fa-solid fa-right-from-bracket"></i>
            <span class="hidden sm:inline">Logout</span>
          </button>
        </div>
      </header>

      <!-- Main content -->
      <main class="flex-1 p-4 sm:p-6 lg:p-8">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import AdminSidebar from '../components/AdminSideBar.vue'
import adminNav from '@/adminNav'

const route = useRoute()
const sidebarOpen = ref(false)

const pageTitle = computed(() => adminNav.find(item => route.path.startsWith(item.to))?.label || 'Admin Panel')

let user = {}
try {
  user = JSON.parse(localStorage.getItem('user') || '{}') || {}
} catch {
  user = {}
}
const userName = user.name || user.email || 'Admin'
const initial = userName.charAt(0).toUpperCase()

// Close the mobile drawer after navigating
watch(() => route.path, () => { sidebarOpen.value = false })

function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  window.location.href = '/login'
}
</script>
